import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4143d3b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-body mt-3 d-flex flex-column justify-content-start align-content-start px-3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-start mb-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-4 fw-bold content-title" })
], -1))
const _hoisted_3 = { class: "d-flex flex-column col-4 p-3" }
const _hoisted_4 = { class: "d-flex col-12 text-start mb-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "可通行時間", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { class: "d-flex flex-column col-4 p-3" }
const _hoisted_8 = { class: "d-flex col-12 text-start mb-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "可通行時間", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_tabs, { type: "border-card" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: _ctx.t('Temporary Access Control Settings - Main Door'),
          class: "d-flex"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_time_picker, {
                  "is-range": "",
                  "range-separator": "至",
                  "start-placeholder": "開始時間",
                  "end-placeholder": "結束時間",
                  modelValue: _ctx.timePicker1.timepicker,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.timePicker1.timepicker) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setTemp1()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("Settings")) + " (臨時門禁1)", 1)
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_el_card, { style: {"max-width":"250px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_image, {
                    src: _ctx.imageSrc,
                    alt: "Base64 Image"
                  }, null, 8, ["src"]),
                  _createVNode(_component_el_divider, { style: {"margin":"15px 0"} }),
                  _hoisted_5,
                  _hoisted_6,
                  _createElementVNode("span", null, _toDisplayString(_ctx.pass.datefrom) + " " + _toDisplayString(_ctx.pass.timefrom) + "~" + _toDisplayString(_ctx.pass.timeto), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_el_time_picker, {
                  "is-range": "",
                  "range-separator": "至",
                  "start-placeholder": "開始時間",
                  "end-placeholder": "結束時間",
                  modelValue: _ctx.timePicker2.timepicker,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.timePicker2.timepicker) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setTemp2()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("Settings")) + " (臨時門禁2)", 1)
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_el_card, { style: {"max-width":"250px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_image, {
                    src: _ctx.imageSrc2,
                    alt: "Base64 Image"
                  }, null, 8, ["src"]),
                  _createVNode(_component_el_divider, { style: {"margin":"15px 0"} }),
                  _hoisted_9,
                  _hoisted_10,
                  _createElementVNode("span", null, _toDisplayString(_ctx.pass2.datefrom) + " " + _toDisplayString(_ctx.pass2.timefrom) + "~" + _toDisplayString(_ctx.pass2.timeto), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    })
  ]))
}